import { red, grey } from '@material-ui/core/colors';
import { createMuiTheme, Theme as MUITheme } from '@material-ui/core';
import personalAgreementBg from '../static/images/personal-agreement-bg.png';
import { BrandsEnum } from '../surveyCollector/SurveyCollector';

const mainColor = '#D5001C';
const starColor = '#000000';
const { spacing } = createMuiTheme();

const myRed = {
  ...red,
  '500': mainColor,
  '600': mainColor,
  A100: mainColor,
  A200: mainColor,
  A400: mainColor,
  A700: mainColor,
};

const fontFamily =
  '"PorscheNextTT", "Helvetica Neue", Helvetica, Arial, sans-serif';

const theme = {
  layout: {
    headerStyle: {
      display: 'flex',
      marginBottom: '20px',
      '@media (max-width: 680px)': {
        marginBottom: '0px',
      }
    },
    headerContentStyle: {
      justifyContent: 'center',
    },
    gridLogo: {
      margin: '0 auto',
      display: 'block'
    },
    languageSelect: {
      position: 'absolute',
      right: 20,
      '@media (max-width: 680px)': {
        position: 'relative',
        right: 'auto',
        marginLeft: 'auto',
      },
    },
  },
  palette: {
    primary: myRed,
    secondary: {
      light: grey.A100,
      main: '#B5B4BA',
      dark: grey.A400,
      contrastText: '#ffffff',
    },
    starColor: starColor,
    background: {
      default: 'ffffff',
    },
  },
  typography: {
    fontFamily: fontFamily,
    useNextVariants: true,
  },
  screenElement: {
    sidePadding: spacing(3),
    sidePaddingXs: spacing(),
  },
  images: {
    introDefaultImagePath: 'images/porshe/introCar.jpg',
    progressImagePath: 'images/porshe/car.jpg',
    logo: 'images/porshe/logo.png',
    favicon: 'favicons/porsche.png',
  },
  personalAgreement: {
    backgroundImagePath: personalAgreementBg,
    continueButtonColor: mainColor,
  },
  title: 'Porsche',
  brandCode: BrandsEnum.PORSCHE,
};

export type PorsheTheme = typeof theme & MUITheme;

export default theme;
